import { IDeleteOriginByNameProtocol, IDeleteOriginByNameProtocolRequest, IDeleteOriginByNameProtocolResponse } from "../../protocols/origin/IDeleteOriginByNameProtocol";
import { IOriginsRepository } from "../../repositories/IOriginsRepository";

export class DeleteOriginByNameUseCase implements IDeleteOriginByNameProtocol {
  constructor(private originsRepository: IOriginsRepository){}
  async execute({originName}: IDeleteOriginByNameProtocolRequest): Promise<IDeleteOriginByNameProtocolResponse> {
    await this.originsRepository.deleteByName(originName)

    return {}
  }
}